import { render, staticRenderFns } from "./DocHubResourceVersionForm.vue?vue&type=template&id=32f4d0e6"
import script from "./DocHubResourceVersionForm.vue?vue&type=script&lang=js"
export * from "./DocHubResourceVersionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports